<template>
  <div class="container-fluid py-5">
    <div class="d-flex justify-content-between">
      <h5>Branch Lists</h5>
      <button
        @click="toggleModal"
        class="bg-success btn text-white rounded py-0 m-0"
        :style="{ height: '35px' }"
      >
        Add New
      </button>
    </div>

    <div class="branches_">
      <div v-for="item in branchs" class="_card" :key="item.id">
        <div class="header">
          <span>
            <Branch /> {{ item.name }}
          </span>
        </div>
        <p>{{ item.address }}</p>
        <div class="d-flex gap-3" >
          <template v-if="hasPermission('2023')">
          <button class="_button_branch" @click="editBranch(item)">Edit Branch</button>
          <button
            class="_button_branch bg-danger text-white"
            @click="deleteBranch(item.id)"
          >
            Delete Branch
          </button>
          </template>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12">
        <div class="card invoice p-0">
          <div
            class="d-lg-flex justify-content-between align-items-center mx-2 pb-0 card-header invoice"
          >
            <h5>Users</h5>
          </div>
          <div class="px-0 pb-0 card-body">
            <div class="table-responsive" v-if="users.length > 0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-sm">Name</th>
                    <th class="text-sm">Email</th>
                    <th class="text-sm">Contact</th>
                    <th class="text-sm">Branch</th>
                    <th class="text-sm">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in users" :key="index">
                    <td class="text-sm">{{ item?.user?.username }}</td>
                    <td>{{ item?.user?.email }}</td>
                    <td class="text-sm">{{ item.number }}</td>
                    <td class="text-sm">{{ item.branch }}</td>
                    <td class="text-sm">
                      <span
                        :class="item.status ? 'active-status' : 'inactive-status'"
                      >
                        {{ item.status ? "Active" : "Inactive" }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <Skalaton />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div v-if="showModal" id="myModal" class="modal_class">
    <div class="modal-content dark-modeon">
      <span @click="toggleModal" class="close text-end">&times;</span>

      <div class="mb-4">
        <h5 class="mb-3">{{ isEditing ? "Edit Branch" : "Add Branch" }}</h5>

        <input
          type="text"
          placeholder="Branch Name"
          class="form-control invoice-card"
          v-model="branchForm.name"
        />
        <input
          type="text"
          placeholder="Address"
          class="form-control invoice-card mt-3"
          v-model="branchForm.address"
        />
        <div class="form-check d-flex align-items-center mt-3">
          <input
            type="checkbox"
            id="isActive"
            class="form-check"
            v-model="branchForm.is_active"
          />
          <label for="isActive" class="form-check-label ms-2">Active</label>
        </div>
      </div>

      <div class="flex text-center">
        <div class="grid grid-cols-2 gap-2">
          <button class="btn btn-secondary mx-3" @click="toggleModal">
            Cancel
          </button>
          <button class="btn btn-success" @click="submitBranch">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useUserApi } from "../services/user.service";
import Branch from "../components/Icon/Branch.vue";
import { hasPermission } from "@/utils/permissions.js";
import showSwal from "@/mixins/showSwal.js"; 

const showModal = ref(false);
const isEditing = ref(false);

const branchForm = ref({
  id: null,
  name: "",
  address: "",
  is_active: true,
});

const branchs = ref([]);
const users = ref([]);

const getBranchData = async () => {
  try {
    const response = await useUserApi().getBranchesData();
    branchs.value = response;
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};

const getUserData = async () => {
  try {
    const response = await useUserApi().getUserData();
    users.value = response;
  } catch (error) {
    console.error("Error fetching users:", error);
  }
};

const toggleModal = () => {
  if (showModal.value) {
    resetForm(); // Resets form when closing the modal
  }
  showModal.value = !showModal.value;
};

const submitBranch = async () => {
  try {
    const apiPayload = {
      name: branchForm.value.name,
      address: branchForm.value.address,
      is_active: branchForm.value.is_active,
    };

    if (isEditing.value) {
      await useUserApi().updateBranch(branchForm.value.id, apiPayload);
    } else {
      await useUserApi().createBranch(apiPayload);
    }

    await getBranchData();
    toggleModal();
  } catch (error) {
    console.error("Error submitting branch:", error);
  }
};

const editBranch = (branch) => {
  if (!hasPermission("2024")) {
    showSwal.methods.showSwal({
            type: "error",
              message: "You do not have permission to perform this action.",
            });
    return;
  }
  isEditing.value = true;
  branchForm.value = { ...branch };
  toggleModal();
};

const deleteBranch = async (branchId) => {
  if (!hasPermission("2024")) {
    showSwal.methods.showSwal({
            type: "error",
              message: "You do not have permission to perform this action.",
            });
    return;
  }
  try {
    await useUserApi().deleteBranch(branchId);
    await getBranchData();
  } catch (error) {
    console.error("Error deleting branch:", error);
  }
};

const resetForm = () => {
  branchForm.value = { id: null, name: "", address: "", is_active: true };
  isEditing.value = false;
};

onMounted(() => {
  getBranchData();
  getUserData();
});
</script>



<style scoped>
.branches_ {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 30px;
}

._card {
  border-radius: 10px;
  padding: 20px;
  color: rgba(0, 0, 0, 0.589);
  display: flex;
  flex-direction: column;
  gap: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.dark-mode ._card {
  background-color: #061f3e;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.avatars {
  display: flex;
  align-items: center;
  gap: 5px;
}

.avatars span {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgb(0, 195, 255);
  transform: translateX(10px);
}

h3 {
  font-size: 16px;
  margin: 0;
}

._button_branch {
  align-self: flex-start;
  color: #4e8aff;
  border: none;
  font-size: 14px;
  padding: 0px 8px;
  border-radius: 10px;
  background-color: #4e89ff1a;
  font-weight: 500;
}

.dark-mode ._button {
  background-color: #4e89ff00;
}

._button:hover {
  background-color: #4e89ff1c;
}

/* ############ modal############### */
/* The Modal (background) */
.modal_class {
  position: fixed;
  z-index: 1000000 !important;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #aaaaaa;
}

/* Modal Content/Box */
.modal-content {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 50%;
  max-width: 650px;
  padding: 20px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/* Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

/* ########################## */
.permissions-wrapper {
  font-family: Arial, sans-serif;
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.permissions-container {
  display: flex;
  flex-direction: column;
}

.permission-header {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  margin-bottom: 8px;
}

.permissions-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-top: 1px solid #e0e0e0;
}

.permissions-row:first-of-type {
  border-top: none;
}

.actions {
  display: flex;
  gap: 10px;
}

.checkbox {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px !important;
}

input[type="checkbox"] {
  width: 14px;
  height: 17px;
  border-radius: 10px !important;
}

._check {
  cursor: pointer !important;
  font-weight: 500 !important;
}

.form-check-input {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.form-check-label {
  font-size: 14px;
  color: #fff; /* Match the text color with the rest of the modal */
  cursor: pointer;
  margin-bottom: 0;
}

.d-flex.align-items-center {
  margin-top: 10px;
}

</style>
